export default "__VITE_ASSET__8a96c6bb__"